export const elevateProductToProductLink = product => {
  const linkObject = {
    id: product?.key, // used in Link state
    name: product?.title, // fallback child text
    primaryRoute: {
      path: product?.link // used as pathname
      //   slug: 'my-product', // only used if you pass categoryPath (and config)
      //   breadcrumbs: [] // used for tracking; can be empty
    }
  };
  return linkObject;
};
